module.exports = __webpack_public_path__ + "img/first_single.9cb614f5.svg";